/**
 * BIN Block Validator — Universal & Direct O(1) Lookup
 */

import { BIN_BLOCK_LIST } from './binBlockList.js';

const ALL_BLOCKED_BINS = new Set();

if (Array.isArray(BIN_BLOCK_LIST)) {
  BIN_BLOCK_LIST.forEach((b) => ALL_BLOCKED_BINS.add(String(b).trim()));
} else if (typeof BIN_BLOCK_LIST === 'object' && BIN_BLOCK_LIST !== null) {
  Object.values(BIN_BLOCK_LIST).forEach((bins) => {
    if (Array.isArray(bins)) {
      bins.forEach((b) => ALL_BLOCKED_BINS.add(String(b).trim()));
    }
  });
}

/**
 * Check if a card number's 6-digit BIN is in the block list.
 * 
 * @param {string} cardNumber - Raw or formatted card number
 * @returns {boolean} true if the card is blocked, false otherwise
 */
export function isBlockedBin(cardNumber) {
  if (!cardNumber) return false;
  const digits = String(cardNumber).replace(/\D/g, '');
  if (digits.length < 6) return false;

  const bin6 = digits.substring(0, 6);
  return ALL_BLOCKED_BINS.has(bin6);
}

export function getBlockedBinsCount() {
  return ALL_BLOCKED_BINS.size;
}
